import React, { Fragment, useRef } from 'react';
import { IParentComponent } from '../interfaces/IParentComponent';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import type { FCWithChildren } from '../../types/FCWithChildren';

interface SimpleModalTWProps extends IParentComponent<HTMLDivElement> {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  titleNode?: React.ReactNode;
}

export const SimpleModalTW: React.FC<SimpleModalTWProps> = (props) => {
  return (
    <GenericModal
      {...props}
      specialClassName={
        'relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6'
      }
    />
  );
};

export const WideModalTW: React.FC<SimpleModalTWProps> = (props) => {
  return (
    <GenericModal
      {...props}
      specialClassName={
        'relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-6xl sm:p-6'
      }
    />
  );
};

interface GenericModalProps extends SimpleModalTWProps {
  specialClassName: string;
}
const GenericModal: FCWithChildren<GenericModalProps> = ({ children, open, setOpen, titleNode, specialClassName }) => {
  const ref = useRef(null);
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen} initialFocus={ref}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900 bg-opacity-20 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={specialClassName}>
                <div className={'flex w-full flex-row items-center py-2 '}>
                  <div className={'grow'}>{titleNode}</div>
                  <div className="pl-2">
                    <button
                      type="button"
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => setOpen(false)}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className="sm:flex sm:items-start" ref={ref}>
                  {children}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
